module.exports = __webpack_public_path__ + "img/wework_white.c3ea24ad.png";